import { StyledListItemContainer } from "./StyledComponents";
import { Checkbox } from "@kaltura/ds-react-components";
import { TruncatedLine } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface ListItemProps {
    name: string;
    id: string;
    isAdded?: boolean;
    onChange: (id: string, isChecked: boolean) => void;
    position?: number;
    totalCount?: number;
}

/**
 * modal's playlists list item
 */
export const ListItem = (props: ListItemProps) => {
    const { name, id, isAdded, onChange, position, totalCount } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(id, e.currentTarget.checked);
    };

    // Include position in aria-label since focus goes to checkbox, not listitem
    const checkboxLabel =
        position && totalCount ? translate("%1, %2 of %3", [name, position.toString(), totalCount.toString()]) : name;

    return (
        <StyledListItemContainer role="listitem" data-testid={`add-to-playlist-list-item-${id}`}>
            <Checkbox
                onChange={handleChange}
                checked={isAdded}
                slotProps={{ input: { "aria-label": checkboxLabel } }}
            />
            <TruncatedLine>{name}</TruncatedLine>
        </StyledListItemContainer>
    );
};
